import { jsxs as l, jsx as i } from "react/jsx-runtime";
import o from "react";
import { b as g, c, L as m, R as v, a as f } from "../chunks/List.97cc6348.js";
import n from "styled-components";
import { R as b } from "../chunks/index.cff5baaf.js";
const y = n(g).withConfig({
  displayName: "ListNavigation",
  componentId: "sc-l9vp6n-0"
})(["height:var(--size-10x) !important;border:var(--default-border-width) solid var(--elements-border-color) !important;border-radius:var(--default-border-radius) !important;padding:0 var(--spacing-1x) 0 var(--spacing-2x) !important;gap:0 !important;&:hover{border-color:transparent !important;}"]), L = n.div.withConfig({
  displayName: "SlotStart",
  componentId: "sc-l9vp6n-1"
})(["display:flex;align-items:center;justify-content:flex-start;gap:var(--spacing-2x);span{overflow:hidden;display:-webkit-box;-webkit-line-clamp:1;-webkit-box-orient:vertical;text-overflow:ellipsis;}p{overflow:hidden;display:-webkit-box;-webkit-line-clamp:2;-webkit-box-orient:vertical;text-overflow:ellipsis;}"]), h = n.div.withConfig({
  displayName: "SlotEnd",
  componentId: "sc-l9vp6n-2"
})(["display:flex;align-items:center;justify-content:flex-end;margin-left:auto;"]), w = n(b).withConfig({
  displayName: "Icon",
  componentId: "sc-l9vp6n-3"
})(["padding-left:var(--spacing-1x);"]), x = o.forwardRef(({
  children: t,
  onClick: a,
  ...e
}, r) => {
  const s = (p) => o.Children.toArray(t).filter((d) => d.props.slot === p);
  return /* @__PURE__ */ l(y, { ref: r, type: c.Line, actionItem: !0, onClick: a, "data-testid": "rango-list-navigation", "data-rango-component": "rango-list-navigation", "data-is-rango": !0, ...e, children: [
    /* @__PURE__ */ l(L, { children: [
      s("type"),
      s("label")
    ] }),
    /* @__PURE__ */ i(h, { children: s("tag") }),
    /* @__PURE__ */ i(w, { icon: "NavigationRightLine" })
  ] });
});
x.displayName = "RangoListNavigation";
const N = {
  ...m
};
Object.values(N);
const R = o.forwardRef(({
  label: t,
  description: a,
  ...e
}, r) => /* @__PURE__ */ i(v, { label: t, description: a, ...e, ref: r }));
R.displayName = "ListNavigationLabel";
const u = o.forwardRef(({
  ...t
}, a) => /* @__PURE__ */ i(f, { ...t, ref: a }));
u.displayName = "RangoListNavigationType";
export {
  N as ListNavigationType,
  x as RangoListNavigation,
  R as RangoListNavigationLabel,
  u as RangoListNavigationType
};
